import { useContext } from "react";
import DateTime from "Components/DateTime";
import AuthorName from "../../components/AuthorName";
import { Info, DateTimeWrapper } from "./About.styled";
import Connect from "../Connect";
import { articleTypes } from "../../Context/ArticleContext";
import { ArticleContext } from "../../Context";
import AuthorAvatar from "../AuthorAvatar";

const About = () => {
  const { refactoredArticle } = useContext<articleTypes>(ArticleContext);
  const {
    path,
    title,
    datePreference,
    authors,
    updated,
    publications,
    articleTypes,
    overrideDate,
    publish,
  } = refactoredArticle;

  const time: any = {
    lastUpdatedDate: updated,
    publishedDate: publish,
    vanityDate: overrideDate,
  };

  const preferedDate = datePreference === "vanityDate" ? overrideDate : publish;
  return (
    <>
      <AuthorAvatar authors={authors}/>
      <Info>
        <AuthorName />
        <DateTimeWrapper>
          <DateTime
            type={
              articleTypes && articleTypes[0]?.name === "Commercial"
                ? "short"
                : "long"
            }
            time={new Date(parseInt(preferedDate) * 1000)}
          />
        </DateTimeWrapper>
        <Connect
          authors={authors}
          publications={publications}
          path={path}
          title={title}
        />
      </Info>
    </>
  );
};

export default About;
